{
  "error": {
    "server_connection_failed": "Server connection failed.  "
  },
  "term": {
    "actuator_endpoint": "Actuator-Endpoint",
    "affects_all_instances": "Affects all {count} instances",
    "affects_this_instance_only": "Affects this instance only",
    "all": "all",
    "application": "Application",
    "applications_tc": "{n} application | {n} applications",
    "attributes": "Attributes",
    "bytes": "Bytes",
    "ok": "OK",
    "cancel": "Cancel",
    "clear": "Clear",
    "cleared": "Cleared",
    "close": "Close",
    "confirm": "Confirm",
    "context_refresh": "Refresh context",
    "context_refresh_failed": "Failed",
    "context_refreshed": "Context refreshed",
    "delete": "Delete",
    "deleted": "Deleted",
    "duration": "Duration",
    "epoch_time": "Epoch Time",
    "percent": "Percent",
    "event": "Event",
    "ever": "ever",
    "execute": "Execute",
    "executing": "Executing...",
    "execution_failed": "Execution failed",
    "execution_successful": "Execution successful",
    "failed": "Failed",
    "fetching_data": "Fetching data...",
    "fetch_failed": "Fetching of data failed.",
    "float": "Float",
    "homepage": "Homepage",
    "filter": "Filter",
    "filter_action": {
      "reset": "Reset filters"
    },
    "hours": "{count} hour | {count} hours",
    "instance": "Instance",
    "instances": "Instances",
    "instances_tc": "{count} instance | {count} instances",
    "integer": "Integer",
    "keyword_search": "Keyword search",
    "menu": {
      "open": "Open menu"
    },
    "milliseconds": "Milliseconds",
    "minutes": "{count} minute | {count} minutes",
    "name": "Name",
    "operations": "Operations",
    "save": "Save",
    "stacktrace": "Stacktrace",
    "suppress": "Suppress",
    "time": "Time",
    "today": "Today",
    "unsuppress": "Unsuppress",
    "no_group": "No Group",
    "username": "Username",
    "go_to_previous_page": "Go to previous page",
    "go_to_page_n": "Go to page {page}",
    "current_page": "Page {page}, current page",
    "go_to_next_page": "Go to next page",
    "no_results_for_term": "No results for \"{term}\"."
  },
  "health": {
    "label": "Health status",
    "status": {
      "DOWN": "down",
      "UP": "up",
      "RESTRICTED": "restricted",
      "UNKNOWN": "unknown",
      "OUT_OF_SERVICE": "out of service",
      "OFFLINE": "offline"
    }
  },
  "time_short": {
    "unknown": "unknown",
    "milliseconds": "{count}ms",
    "seconds": "{count}s",
    "minutes": "{count}min",
    "hours": "{count}h",
    "days": "{count}d",
    "weeks": "{count}wk",
    "months": "{count}mo",
    "years": "{count}y"
  }
}
